"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const fourpaymentsbrand04 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 67 67",
    "aria-labelledby": (title ? `title-fourpaymentsbrand04` : '') + (description ? ` desc-fourpaymentsbrand04` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-fourpaymentsbrand04"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-fourpaymentsbrand04"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M32.429 12.143V39.57h27.428C59.857 54.72 47.577 67 32.43 67 17.28 67 5 54.72 5 39.571c0-15.148 12.28-27.428 27.429-27.428ZM39.57 5C54.72 5 67 17.28 67 32.429H39.571V5Z",
    fill: "#F1C4DC",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#D01481"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M34.571 1a1 1 0 0 1 1-1C51.272 0 64 12.728 64 28.429a1 1 0 0 1-1 1H35.571a1 1 0 0 1-1-1V1Zm2 1.019v25.41h25.41c-.513-13.801-11.609-24.897-25.41-25.41Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 35.571c0-15.7 12.728-28.428 28.429-28.428a1 1 0 0 1 1 1V34.57h26.428a1 1 0 0 1 1 1C56.857 51.272 44.13 64 28.43 64 12.728 64 0 51.272 0 35.571Zm27.429-26.41C13.296 9.687 2 21.311 2 35.571 2 50.167 13.832 62 28.429 62c14.26 0 25.884-11.296 26.41-25.429h-26.41a1 1 0 0 1-1-1V9.161Z"
  }))));
};
var _default = exports.default = fourpaymentsbrand04;